<template>
  <v-col cols="12">
    <v-autocomplete v-model="selectedList" :items="list" dense outlined chips hide-details hide-selected :label="label"
      item-text="name" item-value="uuid" multiple @input="changeData($event)" clearable :search-input.sync="search">
      <template v-slot:selection="data">
        <v-chip small v-bind="data.attrs" :input-value="data.selected" @click:close="remove(data.item)" close>
          <v-avatar left>
            <v-img :src="data.item.profile_image" :size="16"></v-img>
          </v-avatar>
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-avatar>
            <img :src="data.item.profile_image" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.name"></v-list-item-title>
            <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </v-col>
</template>


<script>
export default {
  inheritAttrs: false,
  name: "AutocompleteAvatar",
  props: ["itemText", "itemValue", "storeLink", "selectVale", "id", "label"],

  watch: {
    search(val) {
      if (!val) {
        return;
      }
      console.log(val);

      this.fetchEntriesDebounced(val);
    },

    id() {
      this.fetchEntriesDebounced('');
    },

    selectedList(event) {
      this.changeData(event);
    }
  },

  mounted() {
    this.fetchEntriesDebounced("");
  },

  data: () => ({
    list: [],
    search: null,
    selectedList: []
  }),

  methods: {
    changeData(event) {
      this.$emit("changeData", event);
    },

    remove(item) {
      const index = this.selectedList.indexOf(item.uuid)
      console.log(index);
      if (index >= 0) this.selectedList.splice(index, 1)
    },

    fetchEntriesDebounced(val) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        let data = val;
        if (this.id && this.id != null) {
          data = { uuid: this.id, search: val };
        }
        this.$store
          .dispatch(this.$props.storeLink, data)
          .then((response) => {
            this.list = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.isLoading = false));
      }, 500);
    },
  },
};
</script>

